import React from "react";
import { ThemeProvider } from "@netapp/bxp-design-system-react";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { getItemAnon } from "../../../../jonter/src/utils/localStorage";

const isDarkTheme = getItemAnon({ itemKey: "feature.Platform.BlueXP/DarkTheme" }) || false;

export const ThemeContextController = React.memo(({ children }: { children: any }) => {
  const isActive = useSelector((state: RootState) =>
    state.features.isInitialized ? !!state.features.active["Platform.BlueXP/DarkTheme"] : isDarkTheme
  );
  const isRoot = !import.meta.env.VITE_IS_APP_INTEGRATED_MFE;

  return (
    <ThemeProvider theme={isActive ? "dark" : "light"} isRoot={isRoot} isNewNav={true}>
      {children}
    </ThemeProvider>
  );
});
